import { useMemo } from 'react';
import { getGasCentroid, normalizeCoordinate } from '../helpers';

export const usePentagonRolling = (configuration, series, data, pentagonWidth, pentagonHeight) => {
  return useMemo(
    () =>
      configuration.plots?.map((plot) => {
        let Xrolling = 0;
        let Yrolling = 0;

        return {
          color: plot.rollingAverageColor,
          data:
            series.length >= 5 &&
            data
              ?.filter(
                (d) =>
                  d[plot.h2Id] &&
                  d[plot.c2h6Id] &&
                  d[plot.ch4Id] &&
                  d[plot.c2h4Id] &&
                  d[plot.c2h2Id]
              )
              .map((value, index) => {
                const h2 = value[plot.h2Id];
                const c2h6 = value[plot.c2h6Id];
                const ch4 = value[plot.ch4Id];
                const c2h4 = value[plot.c2h4Id];
                const c2h2 = value[plot.c2h2Id];

                const gasses = [h2, c2h6, ch4, c2h4, c2h2];

                const centroidCoordinates = getGasCentroid(gasses);

                const X =
                  pentagonWidth / 2 +
                  pentagonWidth * (normalizeCoordinate(centroidCoordinates.x) / 100);
                const Y =
                  pentagonHeight / 2 +
                  pentagonHeight * (normalizeCoordinate(centroidCoordinates.y) / 100);

                Xrolling =
                  index === 0
                    ? X
                    : configuration.rollingAverage.decay * Xrolling +
                      (1 - configuration.rollingAverage.decay) * X;

                Yrolling =
                  index === 0
                    ? Y
                    : configuration.rollingAverage.decay * Yrolling +
                      (1 - configuration.rollingAverage.decay) * Y;
                return { X: Xrolling, Y: Yrolling };
              }),
        };
      }),
    [configuration.rollingAverage, data, pentagonWidth, pentagonHeight]
  );
};
export default usePentagonRolling;
